<script setup lang="ts">
import ListConfigurations from '@/components/BusinessLogic/VirtualAgent/ListConfigurators.vue'
import { useRouter } from 'vue-router'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n({ useScope: 'global' })
const router = useRouter()
const locale = computed(() => (router.currentRoute.value.params.locale as string) || 'en')

const goToConfigurator = () => {
  void router.push(`/${locale.value}/configurator`)
}
</script>

<template>
  <DevConfigurator />
  <div class="flex-1 min-h-0 flex flex-col w-full mx-auto h-full px-10 pb-10 pt-10 space-y-6">
    <h1 class="typography-heading-1">{{ t('navigation.virtual_agents') }}</h1>
    <div class="flex-1 min-h-0 flex flex-col">
      <ListConfigurations :locale="locale" @onCreate="goToConfigurator" />
    </div>
  </div>
</template>
